import { render, staticRenderFns } from "./SegundaEtapaAditivoApostilaListagem.vue?vue&type=template&id=453256aa"
import script from "./SegundaEtapaAditivoApostilaListagem.vue?vue&type=script&lang=js"
export * from "./SegundaEtapaAditivoApostilaListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports